import instance from 'api';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IDefectTypeCost } from './interfaces';

export const getDefectTypeCostList = (data: IDynamicTableParams) => {
  return instance()
    .post<IDefectTypeCost[]>('/defectType/cost/list', data)
    .then((response) => response.data);
};

export const getDefectTypeCostAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/defectType/cost/availableColumns')
    .then((response) => response.data);
};

export const getDefectTypeCostAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/defectType/cost/availableGroupColumns')
    .then((response) => response.data);
};
